<template>
    <div class="mt-3">
        <!-- SELECT OBJECT -->
        <el-form-item
            :label="$t.__('dashboard.forms.LastObjectSettingForm.select_objects_to_display')"
            prop="objects"
        >
            <el-select v-model="form.objects" multiple class="wp-4">
                <el-option
                    v-for="object in objectsList"
                    :key="object.value"
                    :label="object.label"
                    :value="object.value"
                >
                </el-option>
            </el-select>
        </el-form-item>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import HumanNameTypeMixins from './../../../mixins/HumanNameTypeMixins.js';

export default {
    mixins: [SettingsFormMixin, HumanNameTypeMixins],
    data() {
        return {
            objectsList: [],
        };
    },
    created() {
        this.cardSettings.objectsAvailables.forEach((object) => {
            const objectWithoutAction = object.substring(0, object.indexOf('.'));
            this.objectsList.push({
                value: object,
                label: this.humanNameType(objectWithoutAction),
            });
        });
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
    },
};
</script>
